import { Grid, Typography } from "@material-ui/core"
import { KeyboardArrowUp } from "@material-ui/icons"
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown"
import React from "react"
import i18n from "../../../../i18nextInitiator"

const t = i18n.getFixedT("fa", "general")

const MoreProvidersDetailBtn = (props) => {
  const { workerDetails, toggleWorkerDetails } = props
  return (
    <Grid item xs={12}>
      <Grid container justifyContent={"flex-end"}>
        <Grid item>
          <Typography
            align={"right"}
            color='primary'
            variant='body2'
            onClick={toggleWorkerDetails}>
            {workerDetails ? t("less") : t("more")}
            {workerDetails ? <KeyboardArrowUp /> : <KeyboardArrowDownIcon />}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}
export default MoreProvidersDetailBtn
